<template>
  <div class="base-wrap">
    <h1>Base – Export</h1>
  </div>
</template>

<script setup>
</script>

<style scoped>

</style>
